import { useTranslation } from 'react-i18next';

const facts = [
  'butlerSchool.japan.fact1',
  'butlerSchool.japan.fact2',
  'butlerSchool.japan.fact3',
  'butlerSchool.japan.fact4',
  'butlerSchool.japan.fact5',
];

function renderParagraphs(text: unknown, className: string) {
  return String(text).split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function JapanPosition() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('butlerSchool.japan.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerSchool.japan.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('butlerSchool.japan.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            t('butlerSchool.japan.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[680px] mx-auto',
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-2 border border-accent-500/20 pointer-events-none hidden md:block"></div>
              <img
                src="/images/generated/facility-odaiba-img.jpg"
                alt={t('butlerSchool.japan.imgAlt')}
                className="relative w-full aspect-[16/10] object-cover object-center"
                loading="lazy"
              />
            </div>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {facts.map((key) => (
                <li
                  key={key}
                  className="flex items-start gap-3 bg-background-100/60 border border-background-200/60 px-4 py-3"
                >
                  <i className="ri-checkbox-circle-line text-accent-500 text-base mt-[3px]"></i>
                  <span className="text-[15px] text-foreground-700 tracking-[0.03em] leading-relaxed">
                    {t(key)}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6 space-y-10">
            <div>
              <h3 className="font-heading text-[19px] md:text-[21px] text-foreground-900 tracking-[0.05em] leading-[1.7] mb-4">
                {t('butlerSchool.japan.h3.1')}
              </h3>
              {renderParagraphs(
                t('butlerSchool.japan.para1'),
                'text-[16px] md:text-[17px] text-foreground-600 tracking-[0.03em] leading-[2.05]',
              )}
            </div>

            <div className="pt-8 border-t border-background-200/70">
              <h3 className="font-heading text-[19px] md:text-[21px] text-foreground-900 tracking-[0.05em] leading-[1.7] mb-4">
                {t('butlerSchool.japan.h3.2')}
              </h3>
              {renderParagraphs(
                t('butlerSchool.japan.para2'),
                'text-[16px] md:text-[17px] text-foreground-600 tracking-[0.03em] leading-[2.05]',
              )}
            </div>

            <div className="pt-8 border-t border-background-200/70">
              <h3 className="font-heading text-[19px] md:text-[21px] text-foreground-900 tracking-[0.05em] leading-[1.7] mb-4">
                {t('butlerSchool.japan.h3.3')}
              </h3>
              {renderParagraphs(
                t('butlerSchool.japan.para3'),
                'text-[16px] md:text-[17px] text-foreground-600 tracking-[0.03em] leading-[2.05]',
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
